import { SiteConfig } from './interfaces/ConfigInterface';
import WCDPConfig from './config/WCDPConfig.json';
import WCDPConfigV2 from './config/WCDPConfigV2.json';
import WCDPTestConfig from './config/WCDPTestConfig.json';
import WCDPTestConfigV2 from './config/WCDPTestConfigV2.json';
import NPMechConfig from './config/NPMechConfig.json';
import NPMechTestConfig from './config/NPMechTestConfig.json';
import NPMechConfigV2 from './config/NPMechConfigV2.json';
import NPMechTestConfigV2 from './config/NPMechTestConfigV2.json';
import TwentyTwentyPHConfig from './config/2020PHConfig.json';
import TwentyTwentyPHTestConfig from './config/2020PHTestConfig.json';
import TwentyTwentyNVConfig from './config/2020NVConfig.json';
import TwentyTwentyNVTestConfig from './config/2020NVTestConfig.json';
import UPFConfig from './config/UPFConfig.json';
import UPFTestConfig from './config/UPFTestConfig.json';
import SBytesConfig from './config/SBytesConfig.json';
import WallcraftConfig from './config/WallcraftConfig.json';
import WallcraftTestConfig from './config/WallcraftTestConfig.json';

import { translator } from './i18n/localization';

const configMap: Record<string, SiteConfig> = {
    wcdp: WCDPConfig as SiteConfig,
    wcdpV2: WCDPConfigV2 as SiteConfig,
    wcdpTest: WCDPTestConfig as SiteConfig,
    wcdpTestV2: WCDPTestConfigV2 as SiteConfig,
    npmech: NPMechConfig as SiteConfig,
    npmechTest: NPMechTestConfig as SiteConfig,
    npmechV2: NPMechConfigV2 as SiteConfig,
    npmechV2Test: NPMechTestConfigV2 as SiteConfig,
    '2020ph': TwentyTwentyPHConfig as SiteConfig,
    '2020phTest': TwentyTwentyPHTestConfig as SiteConfig,
    '2020nv': TwentyTwentyNVConfig as SiteConfig,
    '2020nvTest': TwentyTwentyNVTestConfig as SiteConfig,
    upf: UPFConfig as SiteConfig,
    upfTest: UPFTestConfig as SiteConfig,
    wallcraft: WallcraftConfig as SiteConfig,
    wallcraftTest: WallcraftTestConfig as SiteConfig,
    sbytes: SBytesConfig as SiteConfig,
};

const configKey = process.env.REACT_APP_CONFIG || 'wcdpTest'; // Default to WCDP if no config is specified
const config = configMap[configKey];

if (!config) {
    throw new Error(`Invalid config key: ${configKey}`);
}

translator.setCompany(config.languagePrefix);

export default config;